var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/rar/card/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"alime-rar _item\">\n  <div class=\"alime-rar _info\">\n    <div class=\"alime-rar _photo\">\n      <section class=\"content\">\n        <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
output += "\" />\n      </section>\n    </div>\n    <div class=\"alime-rar _detail\">\n      <h2>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h2>\n      <p class=\"ellipsis\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "detail"), env.opts.autoescape);
output += "</p>\n    </div>\n  </div>\n  <div class=\"alime-rar _reason\">\n    <p class=\"alime-rar _status\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "status"), env.opts.autoescape);
output += "</p>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "status_note")) {
output += "\n      <p class=\"alime-rar _status_note\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "status_note"), env.opts.autoescape);
output += "</p>\n    ";
;
}
output += "\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "status_note") && runtime.contextOrFrameLookup(context, frame, "return_amount")) {
output += "\n      <p class=\"alime-rar _return_amount\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "refundAmountText"), env.opts.autoescape);
output += ": <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "return_amount"), env.opts.autoescape);
output += "</span></p>\n    ";
;
}
output += "\n    <p class=\"alime-rar _reason_text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "returnReasonText"), env.opts.autoescape);
output += ": <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "return_reason"), env.opts.autoescape);
output += "</span></p>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "status_note") && runtime.contextOrFrameLookup(context, frame, "return_amount")) {
output += "\n      <p class=\"alime-rar _return_amount\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "refundAmountText"), env.opts.autoescape);
output += ": <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "return_amount"), env.opts.autoescape);
output += "</span></p>\n    ";
;
}
output += "\n  </div>\n</div>\n\n<div class=\"alime-rar _btn-action\">\n  <button id=\"J_ShowDetails\" data-url=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
output += "\" class=\"btn btn-details\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "viewDetailText"), env.opts.autoescape);
output += "</button>\n</div>\n\n<div class=\"alime-rar _btn-action\">\n  <button id=\"J_ShowMore\" class=\"btn btn-show-more\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "showMoreText"), env.opts.autoescape);
output += "</button>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/rar/card/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/rar/card/tpl.html
// module id = 394
// module chunks = 0 1